import logo from '../eye-mask.svg'
import spotifyLogo from '../assets/spotify_logo.png'

export const AppPromotion = () => {
    return (
        <div className="flex-row center-align relative" style={{backgroundColor: 'yellow'}} >
            <div className='flex-column relative' style={{flexGrow: 1, width: 0, padding: 8}} >
                <div style={{width: '100%',}} >
                    <img src={logo} alt="" style={{ width: '40%' }} />
                    <img src={spotifyLogo} alt="" style={{ width: '50%', objectFit:'contain', paddingLeft: 4 }} />
                </div>
                <h4>Get your masks now</h4>
                <h4>Play Music</h4>
                <h4>Find Mates</h4>
                <h4>Jam together</h4>
                <h4>Message Anonymously</h4>
            </div>
            <div className='relative' style={{ flexGrow: 1, width: 0 }} ><PlayStoreLink /></div>
        </div>

    )
}

const PlayStoreLink = () => {
    return (
        <a href='https://play.google.com/store/apps/details?id=com.codebreakers.saytome&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
            <img style={{ maxWidth: '100%' }} alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' />
        </a>
    );
}